/*
 * File: TreatmentsPlanned.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Displays and styles the Treatments planned for the selected appointment
 */
import React from "react";
import Api from "../Api";
import UIProgress from "components/ui/UIProgress";
import UIListItem from "components/ui/UIListItem";
import { Toolbar } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PatientChart from "services/patients/topofthechart/PatientChart";
import PropTypes from "prop-types";
import MainHeader from "components/MainHeader";
import ApptStore from "services/appointments/store/DataStore";
import { StoreContext } from "utils/useStore";

const styles = theme => ({
  toolbar: {
    padding: theme.spacing(2.5),
    display: "block",
    marginBottom: theme.spacing(0.5),
    marginTop: theme.spacing(2.5)
  }
});

class TreatmentsPlanned extends React.Component {
  state = { loading: true, model: {} };
  static contextType = StoreContext;

  constructor(props) {
    super(props);
    this.aptId = null;
  }

  async componentDidMount() {
    this.apptId = this.context.getStore(ApptStore).selectedAppointmentId();
    if (!this.apptId) {
      this.setState({ loading: false });
      return;
    }
    let res = (await Api.fetchTreatmentPlans(this.apptId)) || [];
    let model = res.length > 0 ? res[0] : {};
    this.setState({ loading: false, model: model });
  }

  formatCharge = charge => {
    return (
      <React.Fragment>
        {charge.code}
        <br />
        {charge.description}
        <br />
        {`$${charge.ammount || "0.00"}`}
      </React.Fragment>
    );
  };

  renderTreatmentPhases() {
    let { model } = this.state;
    if (!model.phases || model.phases.length === 0) return null;
    return model.phases.map((phase, idx) => {
      return (
        <React.Fragment key={idx}>
          <UIListItem label={phase.name} value="" divider={false} />
          {phase.charges &&
            phase.charges.map((charge, idx) => {
              return (
                <UIListItem
                  key={idx}
                  label={"Charge"}
                  value={this.formatCharge(charge)}
                />
              );
            })}
        </React.Fragment>
      );
    });
  }

  render() {
    let { loading, model } = this.state;
    const { classes } = this.props;
    return (
      <React.Fragment>
        <PatientChart />

        <Toolbar className={classes.toolbar}>
          <MainHeader
            pageTitle="Treatments Planned"
            pageSubtitle="Appointment Details"
          />
        </Toolbar>
        {loading && <UIProgress />}
        {!loading && (
          <React.Fragment>
            <UIListItem
              label="Total Treatment Amount"
              value={`$${model.total || "0.00"}`}
              divider={false}
            />
            <UIListItem
              label="Est. Patient Portion"
              value={`$${model.patientPortion || "0.00"}`}
              divider={false}
            />
            <UIListItem
              label="Est. Insurance Portion"
              value={`$${model.insurancePortion || "0.00"}`}
            />
            {this.renderTreatmentPhases()}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

TreatmentsPlanned.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(TreatmentsPlanned);
